<template>
  <generic-update :model="model">
    <template v-slot:form="{ error, fetch, item, loading, submit }">
      <instrument-form
        :with-data="item"
        :error="error"
        :loading="loading"
        @submit="submit"
        @reset="fetch"
      />
    </template>
  </generic-update>
</template>

<script>
import InstrumentForm from "./Form"
import model from "./model"

export default {
  components: { InstrumentForm },
  data() {
    return {
      model,
      localData: {},
    }
  },
}
</script>
